(() => {
	angular.module('main').controller('WorkflowController', WorkflowController);

	WorkflowController.$inject = [
		'$scope',
		'$rootScope',
		'messageService',
		'workflowDataService'
	];

	function WorkflowController(
		$scope,
		$rootScope,
		messageService,
		workflowDataService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,
				pageOrder: {
					predicate: 'name',
					reverse: false
				},
				search: null
			};
			$scope.isDeleteSpinnningWheelActive = false;
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		});

		$scope.deleteWorkflow = (id, name) => {
			$scope.deleteWorkflowName = name;
			$scope.newWorkflow = {
				id
			};
			$('#deleteModal').modal('show');
		};

		$scope.hideModal = function() {
			delete $scope.newWorkflow;
			$('#newWorkflows').modal('hide');
		};

		$scope.deleteRequest = function(id) {
			$scope.isDeleteSpinnningWheelActive = true;
			workflowDataService
				.deleteWorkflow(id)
				.finally(() => ($scope.isDeleteSpinnningWheelActive = false))
				.subscribe(
					data => successDeleteWorkflow(data),
					() => messageService.showToaster('e_6', 'workflow')
				);
		};

		function successDeleteWorkflow(data) {
			if (data.errorMessage) {
				messageService.showToaster('e_2', 'general', data.errorMessage);
			} else {
				messageService.showToaster(
					's_2',
					'workflow',
					$scope.deleteWorkflowName
				);
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				$('#deleteModal').modal('hide');
			}
		}

		$scope.remove = index => {
			if ($scope.newWorkflow.questions.length != 1) {
				$scope.newWorkflow.questions.splice(idList[index - 1], 1);
			}
		};

		function getResultsPage(
			pageNumber = null,
			perPage = null,
			predicate = null,
			reverse = null
		) {
			let changed = false;

			if (predicate && reverse) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (perPage) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}

			if (pageNumber) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if (
				$scope.pageRequest &&
				$scope.totalItems != 0 &&
				$scope.totalItems <
					($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1
			) {
				console.log('out of page');
				$scope.pageRequest.page = 1;
			}

			if (changed) {
				workflowDataService
					.getWorkflowsOnPage($scope.pageRequest)
					.subscribe(
						data => successGetResultsPage(data),
						error => messageService.showDefaultErrorMessage(error)
					);
			}
		}

		function successGetResultsPage(data) {
			if (data && data.pageRequest) {
				$scope.pageRequest = data.pageRequest;
			}
			$scope.pageNumbers = [];
			$scope.totalItems = data ? data.total : 0;

			let pagesCount;
			pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);

			for (let i = 1; i <= pagesCount; i++) {
				$scope.pageNumbers[i - 1] = i;
			}

			$scope.workflows = angular.copy(data.results);
		}

		$scope.order = function(predicate) {
			$scope.pageRequest.pageOrder.reverse =
				$scope.pageRequest.pageOrder.predicate === predicate
					? !$scope.pageRequest.pageOrder.reverse
					: false;
			getResultsPage(
				null,
				null,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};

		$scope.getCurrentPage = function() {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function(newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function(newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};
		$scope.jumpBack = function(disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};
		$scope.jumpAhead = function(disabled) {
			if (!disabled) {
				if (
					$scope.totalItems >=
					$scope.pageRequest.page * $scope.pageRequest.perPage + 1
				) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/workflowController.js